import { ThemeSelectors, TypeFiesta, TypePhantom, TypeSmart } from '@at/design-system-foundation'
import styled, { css } from 'styled-components'
import { Button } from '@at/design-system-elements'
import { Modal } from '@at/design-system-patterns'

const slideModalBreakpoint = '33em' // 528px

export const StyledYourSavedSearchesItem = styled.li`
    list-style-type: none;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.color.border.default};
    li:last-child {
        border: none;
    }
`

export const StyledYourSavedSearchesModalTitle = styled(TypePhantom)`
    color: ${({ theme }) => theme.color.text.title};
    font-size: 26px;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    margin-bottom: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
`

export const StyledYourSavedSearchListing = styled.section`
    max-height: fit-content;
    li:last-of-type {
        border: none;
    }
`

export const StyledNoSavedSearches = styled(TypeFiesta).attrs({ as: 'p' })`
    text-align: center;
`

export const StyledSavedSearchName = styled(TypeFiesta)`
    color: ${({ theme }) => theme.color.text.link.default};
`

export const NewStyledStyledGoToSavedSearchContainer = styled.div`
    padding-left: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) / 2}px;
    width: 7%;
`

export const NewStyledGoToSavedSearchButton = styled.button`
    &:hover {
        & h3 {
            text-decoration: underline;
        }
        svg {
            fill: currentColor;
        }
        color: ${({ theme }) => theme.color.button.text.plain.hover};
    }
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    gap: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 0.5}px;
    padding: 16px 0;
    width: 100%;
    justify-content: space-between;
    & .atds-icon-svg > path {
        fill: currentColor;
    }
`

export const NewStyledYourSavedSearchFilters = styled(TypeSmart)`
    color: ${({ theme }) => theme.color.text.default};
    align-items: center;
    display: inline;
    font-weight: 400;
`

export const StyledModal = styled(Modal)<{ $isMobile?: boolean }>`
    ${({ $isMobile }) => {
        if ($isMobile)
            return css`
                &.your-saved-searches-modal {
                    > section {
                        @media (max-width: 768px) {
                            min-width: 100%;
                        }
                        @media (min-width: ${slideModalBreakpoint}) {
                            transform: translateX(90%);
                        }
                        @media (max-width: 638px) {
                            min-width: 100%;
                            margin: 0;
                        }
                        @media (min-width: 431px) {
                            padding-left: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 5}px;
                            padding-right: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 5}px;
                        }
                        @media (max-width: 430px) {
                            padding-left: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 3}px;
                            padding-right: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 3}px;
                        }
                        @media (max-width: 374px) {
                            padding-left: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
                            padding-right: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
                        }
                    }
                }
            `
    }}
`

export const NewStyledYourSavedSearchListingRow = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const NewStyledSavedSearchesViewAll = styled(Button)`
    display: block;
    margin: 32px auto 0 auto;
    width: fit-content;
`

export const NewStyledYourSaveSearchContainer = styled.div`
    width: 90%;
    text-align: left;
`
